















































































































import { Component, Watch } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import NewsList from "@/components/NewsList.vue";
import LearningCalendar from "@/components/LearningCalendar.vue";
import Footer from "@/components/Footer.vue";
import AuthModule from "@/store/auth";
import UsersApi from "@/services/UsersApi";
import MaterialGroupApi from "@/services/MaterialGroups";
import CheckUserLogin from "@/utils/CheckUserLogin";
import { MaterialGroup, Bookmark, CompleteMaterial, SortDirection, MaterialGroupList } from "@/api/lab-base-api-client";
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import "vue-calendar-heatmap/dist/vue-calendar-heatmap.css";
import "vue-calendar-heatmap/dist/vue-calendar-heatmap.browser";
import dayjs from "dayjs";
import CategoryList from "@/components/material/Categories.vue";

@Component({
  components: {
    Header,
    LearningCalendar,
    NewsList,
    Footer,
    CategoryList,
  },
})
export default class UDashboard extends CheckUserLogin {
  // 今日の日付
  private today: string = dayjs().format("YYYY-MM-DD");

  // 学習カレンダーのデータ
  private calenderDate: { date: string; count: number }[] = [];

  // bookmarkの所属するmaterialGroup
  private bookmarkMaterialGroup: MaterialGroup | null = null;

  private bookmark: Bookmark | null = null;

  private startMaterialGroup: MaterialGroupList | null = null;

  // スタート教材の表示
  private async fetchStartMaterial() {
    // materialGroup取得
    const materialGroupRes = await MaterialGroupApi.instance.getMaterialGroup(
      undefined,
      undefined,
      SortDirection.Asc,
      undefined,
      undefined,
      true
    );

    const materialGroups = materialGroupRes.data.data.items.filter((getWeb: { categories: {} }) => getWeb.categories);

    const materialGroupArr: MaterialGroupList[] = [];

    materialGroups.forEach((materialGroup: MaterialGroup) => {
      for (let i = 0; i < materialGroup.categories.length; i += 1) {
        if (!materialGroup.categories) {
          return;
        }

        // materialGroupArrにmaterialGroupをpushしてwebカテゴリーに属しているmaterialGroupの配列を作る
        if (materialGroup.categories[i].id === 1) {
          materialGroupArr.push(materialGroup);
        }
      }
    });

    // TODO:materialGroupの並び替え機能実装次第コメントアウト外す
    // materialGroupArr.sort((a: { sort: number }, b: { sort: number }) => {
    //   return a.sort - b.sort;
    // });

    // eslint-disable-next-line prefer-destructuring
    this.startMaterialGroup = materialGroupArr[0];
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // アカウント情報の取得
  private async mounted() {
    await this.fetchBookmark();
    if (!this.bookmark) {
      await this.fetchStartMaterial();
    }
    await this.fetchCalendar();
  }

  // BookMark情報の取得
  @Watch("me")
  private async fetchBookmark() {
    if (!this.me?.userDetailUuid) {
      return;
    }
    const bookmarkMaterialGroupsRes = await UsersApi.instance.getBookmarkByUserDetailUuid(this.me.userDetailUuid);
    const bookmarkMaterialGroup = bookmarkMaterialGroupsRes.data.data.bookmark;
    if (!bookmarkMaterialGroup) {
      return;
    }
    this.bookmark = bookmarkMaterialGroup;

    if (!this.bookmark?.materialGroupUuid) {
      return;
    }
    const materialGroupRes = await MaterialGroupApi.instance.getMaterialGroupByUuid(this.bookmark.materialGroupUuid);
    this.bookmarkMaterialGroup = materialGroupRes.data.data?.materialGroup;
  }

  // 学習カレンダー情報取得
  private async fetchCalendar() {
    if (!this.me?.userDetailUuid) {
      return;
    }
    const CompMaterialsRes = await UsersApi.instance.getCompleteMaterialsByUserDetailUuid(this.me.userDetailUuid);

    const compMaterials = CompMaterialsRes.data.data.completeMaterial?.items;
    if (!compMaterials) {
      return;
    }

    compMaterials.forEach((compMaterial: CompleteMaterial) => {
      const day = dayjs(compMaterial.createdAt).format("YYYY-MM-DD");
      const checkedIndex = this.calenderDate.findIndex((compItem: { date: string }) => compItem.date === day);

      // calenderDateにdayと同じ日付がなければ追加
      if (checkedIndex === -1) {
        this.calenderDate.push({ date: day, count: 1 });
        // calenderDateにdayと同じ日付が既にある場合countを1追加
      } else {
        this.calenderDate[checkedIndex].count += 1;
      }
    });
  }
}
